module.exports = __webpack_public_path__ + "img/护理-12.dd5598ec.png";